@import "~@govbr-ds/core/src/components/menu/mixins";
@include menu-header;

:host {
  display: block;

  .menu-title {
    span {
      margin-left: var(--spacing-scale-base);
    }

    ::slotted([slot="signature"]) {
      margin-left: var(--spacing-scale-base);
    }

    ::slotted(img[slot="logo"]) {
      max-height: var(--menu-logo);
    }

    img {
      max-height: var(--menu-logo);
    }
  }
}
